export const blockIconsCommunicationImportExport = (
	<span className='material-symbols-outlined'>import_export</span>
);
